import misRutas from 'vue-routes-generator'
import Main from './App'
import Editor from './componentes/editor/editor'
import Buscador from './componentes/buscador/buscador'
import Agenda from './componentes/agenda/agenda.vue'
import MainStore from '../../core/vue/store/stores'
import RedaccionStore from './store'

export default {
	install: Vue => {
		misRutas.route('/main').child('redaccion', {
			name: 'Redacción',
			component: Main
		})

		misRutas.route('/main').child('redaccion').child('editor/:id', {
			name: 'Editor',
			component: Editor
		})

		misRutas.route('/main').child('redaccion').child('agenda', {
			name: 'Agenda informativa',
			component: Agenda
		})

		misRutas.route('/main').child('redaccion').child('', {
			name: 'Buscador de noticias',
			component: Buscador
		})

		MainStore.registerModule(['redaccion'], RedaccionStore)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/redaccion/vue/index.js